export default class ImplementationManager {
    constructor(api) {
        this.api = api;
    }

    getImplementations = (query, filter, license) =>
        this.api.getImplementations(query, filter, license);

    getImplementationDetail = () => this.api.getImplementationDetail();

    createFavorite = (idImpl) => this.api.createFavorite(idImpl);

    removeFavorite = (idImpl) => this.api.removeFavorite(idImpl);

    getFavorites = () => this.api.getFavorites();

    getLicenses = () => this.api.getLicenses();
}
